export default {

    // 是否折扣活动
    discount: {
        state: false,
        amount: 5,
        btntxt: 'click for 10% off',
        couponCode: 'New_edition_release',
        alertIntv: 24 * 60 * 60,
        channelids: [
            '00100.00000101',
            '00100.00000103',
            '00100.00000121',
            '00100.00000122',
            '00100.00000123',
            '00022.00000105',
            '00022.00000106'
        ],
    },

    // 是否维护中
    maintenance: false,

};


// WEBPACK FOOTER //
// ./app/config/index.js